import * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from '../use-appearance.js';

/**
 * The one toast surface. Sonner is themed through the token variables rather
 * than its own palette so a success toast matches a success badge exactly.
 */
export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  const theme = useTheme();

  return (
    <SonnerToaster
      theme={theme}
      position="bottom-right"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--surface)',
          '--normal-text': 'var(--ink)',
          '--normal-border': 'var(--border)',
          '--success-bg': 'var(--success-bg)',
          '--success-text': 'var(--success)',
          '--success-border': 'var(--success)',
          '--error-bg': 'var(--danger-bg)',
          '--error-text': 'var(--danger)',
          '--error-border': 'var(--danger)',
          '--warning-bg': 'var(--warning-bg)',
          '--warning-text': 'var(--warning)',
          '--warning-border': 'var(--warning)',
          '--border-radius': 'var(--radius-card)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { toast };
